import { WorkflowDeductionSpouseSubBaseService } from 'app/core/workflow/workflow-steps/deduction/spouse/sub/workflow-deduction-spouse-sub-base.service';

export class WorkflowDeductionInfoSpouseHealthService extends WorkflowDeductionSpouseSubBaseService {
  public get title(): string {
    return 'ASIDE_BAR.SPOUSES_DEDUCTION_SUBLIST.HEALTH';
  }

  public get subStepNumber(): number {
    return 8;
  }
}
